
import Vue from "vue";
import { PropType } from "vue";
import { tapestryMixins } from "@/mixins/tapestryMixins";
import { TapestryCivilization, TapestryPlay } from "@/types";

export default Vue.extend({
  name: "TapestryScoresByDate",
  mixins: [tapestryMixins],
  props: {
    civilizations: {
      type: Array as PropType<TapestryCivilization[]>,
      required: true,
      default: [],
    },
    plays: {
      type: Array as PropType<TapestryPlay[]>,
      required: true,
      default: [],
    },
    mainPlayerId: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    sortedPlays(): TapestryPlay[] {
      return this.plays.slice(0).reverse();
    },
  },
});
